import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Select from 'react-select';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import ReactQuill from "react-quill";
import { Modal, IconButton, Box, Tooltip } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

function ApproveRejectWorkPlan() {
    const [planDetails, setPlanDetails] = useState({ date: '', day: '', plan: '' });
    const [selectedDay, setSelectedDay] = useState("");
    const [selectedDate, setSelectedDate] = useState("");  // For the date input
    const [formData, setFormData] = useState({
        retailer_code: "",
        store_name: "",
        email: "",
        abn: "",
        state: "",
        city: "",
        postcode: "",
        street_name: "",
    });


    const [isModalOpen, setIsModalOpen] = useState(false);
    const location = useLocation();
    const { selectedPIDData, selectedDate: passedDate, selectedDay: passedDay } = location.state || {};


    useEffect(() => {
        if (selectedPIDData) {
            setSelectedDate(passedDate);
            setSelectedDay(passedDay);
            setPlanDetails({ ...planDetails, date: passedDate, day: passedDay });
        }
    }, [selectedPIDData, passedDate, passedDay]);


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (
            formData.retailer_code === "" &&
            formData.store_name === "" &&
            formData.email === "" &&
            formData.abn === "" &&
            formData.state === "" &&
            formData.city === "" &&
            formData.postcode === "" &&
            formData.street_name === ""
        ) {
            toast.error("At least one input field must be filled");
            setTableView(false);
            return;
        } else if (formData.street_name && (formData.city === "" && formData.postcode === "")) {
            toast.error("Please enter  post code or city name");
            setTableView(false);
            return;
        } else if (formData.state && (formData.city === "" && formData.postcode === "")) {
            toast.error("Please enter street name or post code");
            setTableView(false);
            return;
        }
    }
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };


    // Handle the selected day change
    const handleDayChange = (selectedOption) => {
        setSelectedDay(selectedOption);
    };

    // Handle the selected date change
    const handleDateChange = (event) => {
        const newDate = event.target.value;
        setSelectedDate(newDate);
        setPlanDetails({ ...planDetails, date: newDate });
    };

    // Modal toggle function
    const handleModalToggle = () => {
        setIsModalOpen(prevState => !prevState);
    };

    // Options for day selection (Monday, Tuesday, etc.)
    const daysOfWeek = [
        { value: 'Monday', label: 'Monday' },
        { value: 'Tuesday', label: 'Tuesday' },
        { value: 'Wednesday', label: 'Wednesday' },
        { value: 'Thursday', label: 'Thursday' },
        { value: 'Friday', label: 'Friday' },
        { value: 'Saturday', label: 'Saturday' },
        { value: 'Sunday', label: 'Sunday' },
    ];

    const getWeekOptions = () => {
        const options = [];
        const currentDate = new Date();

        const currentDay = currentDate.getDay();
        const daysUntilMonday = currentDay === 0 ? -6 : 1 - currentDay;
        currentDate.setDate(currentDate.getDate() + daysUntilMonday);

        for (let i = 0; i < 4; i++) {
            const startOfWeek = new Date(currentDate);
            startOfWeek.setDate(currentDate.getDate() + i * 7);

            const endOfWeek = new Date(startOfWeek);
            endOfWeek.setDate(startOfWeek.getDate() + 4);

            const weekLabel = `${startOfWeek.toLocaleString('default', { month: 'short' })} ${startOfWeek.getDate()} - ${endOfWeek.toLocaleString('default', { month: 'short' })} ${endOfWeek.getDate()}`;
            const weekRange = { start: startOfWeek.toISOString().split('T')[0], end: endOfWeek.toISOString().split('T')[0] };
            options.push(<option key={i} value={JSON.stringify(weekRange)}>{weekLabel}</option>);
        }

        return options;
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <div className="container">
                <form className="workplanform col-lg-12">
                    <div className="flex-container">
                        <div className="work-details">
                            <h4> Approve/Reject daily work </h4>
                            <br />

                            {/* Two-column layout for Select Date and Select Day */}
                            <div className="row">
                                {/* Date Selection */}
                                <div className="col-md-6">
                                    <div className="work-day-selection">
                                        <label htmlFor="work-date" className="label">Select the Work Week:</label>

                                        <select id="work-week" name="work-week" className="select" onChange={handleDateChange}>
                                            <option value={selectedDate}>Please choose an option</option>
                                            {getWeekOptions()}
                                        </select>


                                    </div>
                                </div>

                                {/* Day Selection */}
                                <div className="col-md-6">
                                    <div className="work-day-selection">
                                        <label htmlFor="work-day" className="label">Select a Day:</label>
                                        <Select
                                            id="work-day"
                                            options={daysOfWeek}
                                            value={selectedDay ? { value: selectedDay, label: selectedDay.label } : null}
                                            onChange={handleDayChange}
                                            placeholder="Select a day"
                                            className="basic-single"
                                            classNamePrefix="select"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="row align-items-center mb-3">
                        <label htmlFor="plan-details" className="label col-12">Edit Work Plan Details:</label>

                        <div className="col-md-8">
                            <Select
                                isMulti
                                options={[]} // Populate with your store options
                                value={[]}  // Replace with selected store options
                                onChange={(selectedOptions) => { }}
                                placeholder="Search and add store for revisiting ..."
                                className="basic-multi-select"
                                classNamePrefix="select"
                            />
                        </div>

                        <div className="col-md-1">
                            <Tooltip title="Search details of stores" placement="bottom-end">
                                <IconButton onClick={handleModalToggle} aria-label="search" style={{ marginLeft: '10px' }}>
                                    <SearchIcon sx={{ color: '#e20e75', transition: 'transform 0.2s' }} />
                                </IconButton>
                            </Tooltip>
                        </div>


                        <div className="col-md-12 mt-3">
                            {/* Editor for plan */}
                            <ReactQuill
                                value={formData.plan || ''}
                                onChange={(value) => setFormData({ ...formData, plan: value })}
                                placeholder="Provide your planned activities."
                                modules={{
                                    toolbar: [
                                        [{ 'header': [1, 2, false] }],
                                        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                                        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                        ['link'],
                                        ['clean']
                                    ]
                                }}
                                style={{ borderColor: '#e20e75', borderRadius: '5px', height: '150px', marginBottom: "55px" }}
                            />
                        </div>

                    </div>


                    <div className="row align-items-center mb-3">
                        <label htmlFor="plan-details" className="label col-12">Reporting Manager Comment:</label>

                        <div className="col-md-12 mt-3">
                            {/* Editor for plan */}
                            <ReactQuill
                                value={formData.plan || ''}
                                onChange={(value) => setFormData({ ...formData, plan: value })}
                                placeholder="Provide your planned activities."
                                modules={{
                                    toolbar: [
                                        [{ 'header': [1, 2, false] }],
                                        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                                        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                        ['link'],
                                        ['clean']
                                    ]
                                }}
                                style={{ borderColor: '#e20e75', borderRadius: '5px', height: '150px', marginBottom: "55px" }}
                            />
                        </div>

                        <div className="text-end">
                            <button type="button" className="btn btn-success col-lg-4">Approve</button>
                            <button type="button" className="btn btn-danger ms-2 col-lg-4">Reject</button>
                        </div>
                    </div>


                </form>
            </div>


            <Modal open={isModalOpen} onClose={handleModalToggle}>

                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 600,
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        p: 4,
                        borderRadius: 2,
                    }}
                >
                    <form action="" method="" onSubmit={handleSubmit} autoComplete="off">
                        <div className="formbold-mb-5 formbold-pt-3">
                            <label className="formbold-form-label formbold-form-label-2">
                            </label>
                            <div className="flex flex-wrap formbold--mx-3">
                                <div className="w-full sm:w-half formbold-px-3">
                                    <label htmlFor="store_name" className="formbold-form-label">
                                        Store Name
                                    </label>
                                    <div className="formbold-mb-5">
                                        <input
                                            type="text"
                                            name="store_name"
                                            id="store_name"
                                            placeholder="Enter Store Name"
                                            className="form-control"
                                            value={formData.store_name}
                                            onChange={handleChange}
                                            autoComplete="off"
                                        />
                                    </div>
                                </div>

                                <div className="w-full sm:w-half formbold-px-3">
                                    <div className="formbold-mb-5">
                                        <label htmlFor="store_name" className="formbold-form-label">
                                            Email  Address
                                        </label>
                                        <input
                                            type="email"
                                            name="email"
                                            id="email"
                                            placeholder="Enter Email Address"
                                            className="form-control"
                                            value={formData.email}
                                            onChange={handleChange}
                                            autoComplete="off"
                                        />
                                    </div>
                                </div>

                                <div className="w-full sm:w-half formbold-px-3">
                                    <div className="formbold-mb-5">
                                        <label htmlFor="store_name" className="formbold-form-label">
                                            Retailer ID
                                        </label>
                                        <input
                                            type="text"
                                            name="retailer_code"
                                            id="retailer_code"
                                            placeholder="Enter Retailer ID"
                                            className="form-control"
                                            value={formData.retailer_code}
                                            onChange={handleChange}
                                            autoComplete="off"
                                        />
                                    </div>
                                </div>
                                <div className="w-full sm:w-half formbold-px-3">
                                    <div className="formbold-mb-5">
                                        <label htmlFor="store_name" className="formbold-form-label">
                                            ABN
                                        </label>
                                        <input
                                            type="text"
                                            name="abn"
                                            id="abn"
                                            placeholder="Enter ABN"
                                            className="form-control"
                                            value={formData.abn}
                                            onChange={handleChange}
                                            maxLength={12}
                                            autoComplete="off"
                                        />
                                    </div>
                                </div>

                                <div className="w-full sm:w-half formbold-px-3">
                                    <div className="formbold-mb-5">
                                        <label htmlFor="store_name" className="formbold-form-label">
                                            City
                                        </label>
                                        <input
                                            type="text"
                                            name="city"
                                            id="city"
                                            placeholder="Enter City Name"
                                            className="form-control"
                                            value={formData.city}
                                            onChange={handleChange}
                                            autoComplete="new-password"
                                        />
                                    </div>
                                </div>
                                <div className="w-full sm:w-half formbold-px-3">
                                    <div className="formbold-mb-5">
                                        <label htmlFor="store_name" className="formbold-form-label">
                                            Post Code
                                        </label>
                                        <input
                                            type="text"
                                            name="postcode"
                                            id="postcode"
                                            placeholder="Enter Post Code"
                                            className="form-control"
                                            value={formData.postcode}
                                            onChange={handleChange}
                                            autoComplete="new-password"
                                        />
                                    </div>
                                </div>
                                <div className="w-full sm:w-half formbold-px-3">
                                    <div className="formbold-mb-5">
                                        <label htmlFor="store_name" className="formbold-form-label">
                                            Street Name
                                        </label>
                                        <input
                                            type="text"
                                            name="street_name"
                                            id="street_name"
                                            placeholder="Enter Street Name"
                                            className="form-control"
                                            value={formData.street_name}
                                            onChange={handleChange}
                                            autoComplete="new-password"
                                        />
                                    </div>
                                </div>

                                <div className="w-full sm:w-half formbold-px-3">
                                    <label htmlFor="store_name" className="formbold-form-label">
                                        State
                                    </label>
                                    <select
                                        className="form-control"
                                        name="state"
                                        id="state"
                                        value={formData.state}
                                        onChange={handleChange}
                                    >
                                        <option value="">Select State</option>
                                        <option value="Act">ACT</option>
                                        <option value="NSW">NSW</option>
                                        <option value="NIT">NIT</option>
                                        <option value="QLD">QLD</option>
                                        <option value="SA">SA</option>
                                        <option value="TAS">TAS</option>
                                        <option value="VIC">VIC</option>
                                        <option value="WA">WA</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="search-store-buttons">
                            <button className="search-store-button" type="submit"><i class="fa fa-search"></i> Search</button>

                        </div>

                    </form>
                </Box>
            </Modal>



        </DashboardLayout>
    );
}

export default ApproveRejectWorkPlan;
